import api from '../utils/api';

export const getMessageTemplate = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messageTemplate/getAllMessageTemplates/${data}`,
        method: "GET",
        data: data,
        ...options,
    });
}


export const addEditMessageTemplate = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messageTemplate/addUpdateMessageTemplate`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const deleteTemplate = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messageTemplate/deleteMessageTemplateById/${data}`,
        method: "DELETE",
        data: data,
        ...options,
    });
}

export const getAllAutomatedTemplateKey = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/messageTemplate/getAllAutomatedTemplateKey',
        method: 'GET',
        ...options,
    });
};
